<!-- eslint-disable no-undef -->
<template>
  <v-container fluid>
    <v-layout justify-center align-start v-if="!data || !data._id" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <div class="title pa-3">{{ $t('no_account_selected') }}</div>
            <v-layout row wrap pt-2 justify-center>
              <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line class="br-10" dense v-if="data && data._id">
      <v-subheader><h3>{{ $t('booking_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data._id.replace(/BOOKING-/g, '') }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.created_at | dateTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('booking_date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.from_date | date }} - {{ data.to_date | date }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('booking') }} {{ $t('from_date') }} - {{ $t('to_date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-list fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ $t(data.bookingType) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('bookingType') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">
            fa-list fa-lg
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ data.selected_booking_facility.name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('venue') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.bookingType === 'venue'">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">
            fa-map-marker fa-lg
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <div class="body-2 text-uppercase">
            {{ data.selected_booking_facility.building_number }}, LOT: {{ data.selected_booking_facility.lot || "-" }}, BLOK: {{ data.selected_booking_facility.block || "-" }}, FL: {{ data.selected_booking_facility.floor || "-" }},<br /> {{ data.selected_booking_facility.location }}
          </div>
          <v-list-item-subtitle class="body-2">{{ $t('location') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">
            {{ data.bookingType === 'venue' ? 'fa-map-marker fa-lg' : 'fa-cubes fa-lg' }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ data.event }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('event') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">
            fa-dollar fa-lg
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase">{{ data.amount | ringgit }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('amount_rm') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-stack-exchange fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2" style="white-space: pre-line">
            {{ data.additional_request || "-" }}
          </v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('additional_request') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2 text-uppercase" :class="{ 'green--text': data.status === 'confirmed', 'orange--text': data.status === 'pending_approval' || data.status === 'pending_payment', 'error--text': data.status === 'rejected' }">
            <strong>{{ $t(data.status) }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="data.rejected_reason && data.rejected_reason.length > 0">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-comment fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <div class="body-2 font-weight-bold">{{ data.rejected_reason }}</div>
          <v-list-item-subtitle class="body-2">{{ $t('rejected_reason') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-row justify="center" align="center" v-if="data.booking_id && data.booking_id.length > 0 && data.status !== 'pending_approval' && data.status !== 'new'">
      <v-col cols="12" class="text-center">
        <qrcode-vue :value="data.booking_id" size="100" level="H"></qrcode-vue>
      </v-col>
    </v-row>
    <br>
    <v-list two-line class="br-10" dense v-if="data && data.selected_time_slot">
      <v-subheader><h3>{{ $t('timeslot') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item v-for="(timeslot, i) in data.selected_time_slot" :key="i">
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-clock-o fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ timeslot.startTime }} - {{ timeslot.endTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ timeslot.date | date }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data && data._id && data.customer">
      <v-subheader><h3>{{ $t('customer_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer.name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('name', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer.nric }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ic_num', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-phone fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer.phone }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('phone', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-at fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.customer.email }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('email', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-row justify="space-around" align="center" v-if="data.booking_id && data.booking_id.length > 0">
      <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '6'" class="text-center" v-if="data.confirmationLetter && data.confirmationLetter.length > 0 && data.status === 'confirmed'">
        <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" large rounded @click="downloadApprovalLetter">
          {{ $t('download_confirmation_letter' )}}
        </v-btn>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '6'" class="text-center" v-if="data.status === 'pending_payment'">
        <v-btn :block="$vuetify.breakpoint.xsOnly" color="teal" class="white--text" large rounded @click="payOnline">
          {{ $t('page_assessment.pay_online' )}}
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog max-width="80%" :value="feedbackDialog" persistent>
      <rating-card v-if="data._id" :id="data._id" @hide="feedbackDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from '../../axios'
import QrcodeVue from 'qrcode.vue'
import configurations from '../../configurations'
import RatingCard from '../RatingCard'

export default {
  async beforeMount () {
    await this.fetchData(this.$route.params.id)
    if (this.$route.query.feedback === 'true') {
      const { data: response } = await axios.get(`${configurations.WORKER}/rating/reference_number/${this.$route.params.id}?type=e-services`)
      if (response.rows.length === 0 || response.rows[0].value === 0) {
        this.feedbackDialog = true
      }
    }
  },
  data: () => ({
    data: {},
    images: [],
    index: null,
    options: { continuous: false },
    feedbackDialog: false
  }),
  components: {
    QrcodeVue,
    RatingCard
  },
  methods: {
    async downloadApprovalLetter () {
      this.loading = true
      try {
        const response = await axios({
          url: `${configurations.WORKER}/bookings/getAttachments/${this.data.booking_id}/${this.data.confirmationLetter}`,
          method: 'GET',
          responseType: 'arraybuffer'
        })
        const base64 = 'data:application/pdf;base64,' + Buffer.from(response.data, 'binary').toString('base64')

        if (!window.hasOwnProperty('cordova')) {
          const url = base64
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${this.data.confirmationLetter}`)
          document.body.appendChild(link)
          link.click()
          return
        }

        // mobile code start
        const storageLocation = cordova.file.externalApplicationStorageDirectory
        const fileName = this.data.confirmationLetter
        var errorCallback = function (error) {
          console.log(error)
        }
        window.resolveLocalFileSystemURL(storageLocation,
          function (directory) {
            directory.getFile(fileName, {
              create: true,
              exclusive: false
            },
            function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                writer.onwriteend = function () {
                  cordova.plugins.fileOpener2.open(
                    storageLocation + fileName,
                    'application/pdf',
                    {
                      error: function (error) {
                        console.log('Error status: ' + error.status + ' - Error message: ' + error.message)
                      },
                      success: function () {
                        console.log('file opened successfully')
                      }
                    }
                  )
                }
                writer.seek(0)
                writer.write(base64)
              }, errorCallback)
            }, errorCallback)
          }, errorCallback)
      // mobile code end
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Failed to download.',
          visible: true
        })
      } finally {
        this.loading = false
      }
    },
    payOnline () {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configurations.host.epayment}/#/confirmation?_id=${
          btoa(this.data._id.replace(/BOOKING-/g, ''))
        }&council=${configurations.council}&payment_type=${this.data.type}`
        return
      }

      // mobile code start
      let ref = cordova.InAppBrowser.open(`${configurations.host.epayment}/#/confirmation?_id=${
        btoa(this.data._id.replace(/BOOKING-/g, ''))
      }&council=${configurations.council}&payment_type=${this.data.type}`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 31) === `${configurations.host.epayment}/#/receipt?`) {
          params = event.url.substring(31, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configurations.host.epayment}/index.html#/` || event.url === `${configurations.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))

      // mobile code end
    },
    async fetchData (id) {
      this.loading = true
      try {
        const response = await axios({
          url: `${configurations.WORKER}/bookings/${id}`,
          method: 'GET',
          headers: {
            'x-booking-id': btoa(id)
          }
        })
        this.data = response.data
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: 'Failed to fetch data.',
          visible: true
        })
        this.$router.go(-1)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
